const PAYMENT_MODE_CUSTOMER_LABELS = new Set([
  "cash",
  "card",
  "upi",
  "credit",
  "split",
]);

const normalizeText = (value) => String(value ?? "").trim();

const getOrderPaymentMode = (order = {}) =>
  normalizeText(
    order?.payment_mode ||
      order?.paymentMode ||
      order?.paymentmode ||
      order?.mode
  ).toLowerCase();

const getPartyDisplayName = (party = {}) =>
  normalizeText(
    party?.partyname ||
      party?.customer_name ||
      party?.customerName ||
      party?.party_name ||
      party?.partyName ||
      party?.name ||
      party?.company_name ||
      party?.companyname
  );

const isPaymentModePlaceholder = (value, paymentMode = "") => {
  const normalized = normalizeText(value).toLowerCase();
  if (!normalized) return false;
  return (
    PAYMENT_MODE_CUSTOMER_LABELS.has(normalized) ||
    (!!paymentMode && normalized === normalizeText(paymentMode).toLowerCase())
  );
};

const getCustomerCandidates = (order = {}) => [
  order?.customer_name,
  order?.customerName,
  order?.party_name,
  order?.partyName,
  order?.customername,
  order?.partyname,
  order?.customer,
  order?.name,
];

export const getOrderPartyId = (order = {}) => {
  const raw =
    order?.partyid ??
    order?.party_id ??
    order?.customer_id ??
    order?.customerId ??
    order?.selectedpartyid ??
    null;
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

export const buildPartyLookup = (list = []) => {
  const lookup = {};
  if (!Array.isArray(list)) return lookup;
  list.forEach((party) => {
    const id = Number(party?.id ?? party?.partyid ?? party?.party_id);
    if (Number.isFinite(id) && id > 0) {
      lookup[id] = party;
    }
  });
  return lookup;
};

export const resolveCustomerName = (order = {}, partyLookup = {}) => {
  const partyId = getOrderPartyId(order);
  if (partyId && partyLookup?.[partyId]) {
    const partyName = getPartyDisplayName(partyLookup[partyId]);
    if (partyName) return partyName;
  }

  const paymentMode = getOrderPaymentMode(order);
  for (const candidate of getCustomerCandidates(order)) {
    const normalized = normalizeText(candidate);
    if (!normalized) continue;
    if (isPaymentModePlaceholder(normalized, paymentMode)) continue;
    return normalized;
  }

  return "";
};

export const getCustomerDisplayLabel = ({
  order = {},
  partyLookup = {},
  showPaymentModeOnBill = true,
  defaultCashLabel = "CASH",
} = {}) => {
  const customerName = resolveCustomerName(order, partyLookup);
  if (customerName) return customerName;
  if (!showPaymentModeOnBill) return defaultCashLabel;
  return getOrderPaymentMode(order) === "cash" ? defaultCashLabel : "";
};
